<template>
    <div>
        <v-treeview
            activatable
            hoverable
            transition
            :items="getTreeviewDate"
            return-object
            :open.sync="selectedItemInMenu"
            :active.sync="active"
            color="warning"
        >
            <template slot="prepend" slot-scope="{ item, open }">
                <svg
                    v-if="item.type == 'summary' && !item.parent"
                    width="25"
                    height="25"
                    viewBox="0 0 23 16"
                >
                    <use xlink:href="#summary-icon" />
                </svg>
                <svg
                    v-if="item.type == 'report' && !item.parent"
                    width="24"
                    height="24"
                    viewBox="0 0 15 18"
                >
                    <use xlink:href="#report-icon" />
                </svg>
                <v-icon v-if="item.parent" color="#2196F3">
                    {{
                        open ? "mdi-folder-open-outline" : "mdi-folder-outline"
                    }}
                </v-icon>
            </template>
        </v-treeview>
    </div>
</template>
<script>
export default {
    name: "ReportsMenu",
    data: () => {
        return {
            treeviewOpenedElements: null,
            active: [],
            selectedItemInMenu: [],
        };
    },
beforeDestroy(){
        this.$store.dispatch('saveActiveReport', this.active)
        this.$store.dispatch('saveSelectedItemInMenu', this.selectedItemInMenu)
    },
    mounted(){
        if(this.$store.getters.activeReport.length){
            this.active = this.$store.getters.activeReport
            this.selectedItemInMenu = this.$store.getters.selectedItemInMenu
        }
    },
    watch: {
        active: function () {
            this.$emit("fetchDocuments", this.active);
        },

    },
    computed: {
        getTreeviewDate() {

            return [
                {
                    id: "summaries",
                    name: this.$t('tooltips.automaticSummaries'),
                    parent: "Root",
                    type: "summary",
                    children: this.$store.getters.summariesList,
                },
                {
                    id: "reports",
                    name: this.$t('tooltips.customReports'),
                    parent: "Root",
                    type: "report",
                    children: this.$store.getters.reportsList,
                },
            ]
        }

    },
};
</script>
